import GameManager from '../../../core/GameManager';
import { ScenarioSceneType, ScenarioEndType } from '../../../misc/BleedingControlScenario';
import MainPracticeScenario from './MainPracticeScenario/MainPracticeScenario';
import {getPracticeAScenario} from './practiceStartText';

export default class PracticeScenarioA extends MainPracticeScenario {


	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName, ScenarioSceneType.scenarioA, ScenarioEndType.pressureDressing, [], true, 0.55, 0.74, null, null, null, null, null, null, true, false, false, false, 'Hit By Vehicle - Practice Scenario', getPracticeAScenario());
	}

	public get totalNumberOfQuestions(): number {
		return 5;
	}

	public soundFolderAndPath(section: string, part: string): string {
		return '06-Scenario A/BC-Scenario-A-'  + section + '-Part-' + part;
	}
}